/* iFungi shared sticky cart — homepage LF7, LF7 PDP, PS7 PDP
 * Draft implementation for Copy of Theme 43.
 * 2026-10-13 (Claude, audit): French bag word is "sachet(s)" like the buy boxes (was "sac");
 * the missing-price guard checks the number itself, so it works in French ("0,00 $") too.
 * One state controller mirrors the authoritative buy-box state and delegates
 * purchases to the existing main Add to Cart buttons.
 */
(function () {
  'use strict';

  var IS_FR = (document.documentElement.lang || '').toLowerCase().indexOf('fr') === 0;

  if (window.__ifungiStickyCartLoaded) return;
  window.__ifungiStickyCartLoaded = true;

  var components = [];

  function cleanText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function plural(value, singular, pluralForm) {
    return value === 1 ? singular : (pluralForm || singular + 's');
  }

  function bagCount(quantityLabel) {
    var parsed = parseInt(String(quantityLabel || '1').match(/\d+/), 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
  }

  function formatMoney(amount, state) {
    if (!Number.isFinite(Number(amount))) return '';
    /* French renders 24,99 $ — see snippets/ifungi-money.liquid and the
       window.iFungiMoney helper declared in snippets/js-variables.liquid. */
    if (window.iFungiMoney) return window.iFungiMoney.fromAmount(Number(amount));
    var symbol = state && state.currSymbol ? state.currSymbol : '$';
    return symbol + Number(amount).toFixed(2);
  }

  function stickyPriceLabel(state) {
    if (!state || !state.price) return '';
    if (state.purchaseType !== 'subscribe' && Number(state.bags) >= 1) {
      return state.price + ' (' + state.bags + ' ' + plural(Number(state.bags), IS_FR ? 'sachet' : 'bag') + ')';
    }
    return state.price;
  }

  function purchaseType(prefix) {
    var checked = document.querySelector('input[name="' + prefix + '-purchase-type"]:checked');
    return checked ? checked.value : 'subscribe';
  }

  function frequencyLabel(prefix) {
    var fallback = IS_FR ? 'Abonnement' : 'Subscribe';
    var select = document.getElementById(prefix + '-delivery-freq');
    if (!select || !select.options || select.selectedIndex < 0) return fallback;
    var text = cleanText(select.options[select.selectedIndex].textContent);
    return cleanText(text.split(/—|–/)[0]) || fallback;
  }

  function conciseProductTitle(product) {
    return product === 'ps7' ? 'PetShrooms 7' : 'Life Force 7';
  }

  function readLF7(component) {
    var state = window.lf7State || {};
    var variants = window.lf7Variants || {};
    var activeSize = document.querySelector('#lf7-size-row .lf7-variant-btn.active');
    var size = state.currentSize || (activeSize && activeSize.getAttribute('data-size')) || '150g';
    var type = purchaseType('lf7');
    var quantity = type === 'subscribe' ? '1 Bag' : (state.currentQty || '1 Bag');
    var variant = variants[size] && variants[size][quantity];
    var bags = variant && variant.bags ? Number(variant.bags) : bagCount(quantity);
    var servingsPerBag = size === '150g' ? 150 : 60;
    var servings = servingsPerBag * bags;
    var discount = type === 'subscribe' ? Number(state.currentSubDiscount || 0) : 0;
    var total = variant && Number(variant.price);
    /* The buybox exposes its exact selected Shopify allocation. Keep percentage maths
       only as a compatibility fallback for an older buybox asset. */
    var selected = type === 'subscribe' ? Number(state.currentPrice) : NaN;
    if (Number.isFinite(selected) && selected > 0) total = selected;
    else if (Number.isFinite(total) && discount > 0) total = Math.round(Math.round(total * 100) * (100 - discount) / 100) / 100;

    var baseTitle = conciseProductTitle('lf7');

    return {
      product: 'lf7',
      title: type === 'subscribe' ? baseTitle + (IS_FR ? ' - Abonnement' : ' - Subscription') : baseTitle,
      total: total,
      price: formatMoney(total, state),
      size: size,
      servings: servings,
      bags: bags,
      purchaseType: type,
      frequency: type === 'subscribe' ? frequencyLabel('lf7') : '',
      quantity: quantity
    };
  }

  function readPS7(component) {
    var state = window.ps7State || {};
    var variants = window.ps7Variants || {};
    var type = purchaseType('ps7');
    var quantity = type === 'subscribe' ? '1 Bag' : (state.currentQty || '1 Bag');
    var variant = variants[quantity];
    var bags = variant && variant.bags ? Number(variant.bags) : bagCount(quantity);
    var servings = 100 * bags;
    var discount = type === 'subscribe' ? Number(state.currentSubDiscount || 0) : 0;
    var total = variant && Number(variant.price);
    /* The buybox exposes its exact selected Shopify allocation. Keep percentage maths
       only as a compatibility fallback for an older buybox asset. */
    var selected = type === 'subscribe' ? Number(state.currentPrice) : NaN;
    if (Number.isFinite(selected) && selected > 0) total = selected;
    else if (Number.isFinite(total) && discount > 0) total = Math.round(Math.round(total * 100) * (100 - discount) / 100) / 100;

    var baseTitle = conciseProductTitle('ps7');

    return {
      product: 'ps7',
      title: type === 'subscribe' ? baseTitle + (IS_FR ? ' - Abonnement' : ' - Subscription') : baseTitle,
      total: total,
      price: formatMoney(total, state),
      servings: servings,
      bags: bags,
      purchaseType: type,
      frequency: type === 'subscribe' ? frequencyLabel('ps7') : '',
      quantity: quantity
    };
  }

  /* 2026-10-13: numeric check on the amount itself; the old text pattern only knew "$0.00". */
  function isUsablePrice(state) {
    var total = state ? Number(state.total) : NaN;
    return !!(state && state.price) && Number.isFinite(total) && total > 0;
  }

  function schedule(component) {
    if (component.__ifungiSyncQueued) return;
    component.__ifungiSyncQueued = true;
    window.requestAnimationFrame(function () {
      component.__ifungiSyncQueued = false;
      sync(component);
    });
  }

  function sync(component) {
    var product = component.getAttribute('data-product');
    var state = product === 'ps7' ? readPS7(component) : readLF7(component);
    var title = component.querySelector('[data-ifungi-sticky-title]');
    var price = component.querySelector('[data-ifungi-sticky-price]');
    var button = component.querySelector('[data-ifungi-sticky-atc]');
    var mainButton = document.querySelector(component.getAttribute('data-main-atc'));
    var priceLabel = stickyPriceLabel(state);
    state.priceLabel = priceLabel;

    if (title && state.title) title.textContent = state.title;
    if (price && isUsablePrice(state)) price.textContent = priceLabel;

    if (button) {
      var defaultLabel = button.getAttribute('data-default-label') || (IS_FR ? 'AJOUTER AU PANIER' : 'ADD TO CART');
      var mainBusy = !!(mainButton && mainButton.disabled);
      button.disabled = mainBusy;
      /* 2026-10-03 (Tranche 7): when the main button has become "View cart" (add outcome
         unconfirmed), the sticky bar says the same, since tapping it taps the main button.
         2026-10-03 (Tranche 8, audit A3): a disabled main button is not necessarily "Adding…" —
         it also says "Checking your cart…" (load/Back with an unconfirmed add, View-cart tap)
         or "Unavailable". Mirror its own words in those states instead of a hard-coded label. */
      var viewCart = !!(mainButton && mainButton.getAttribute('data-ifungi-view-cart') === 'true');
      var mainText = mainButton ? String(mainButton.textContent || '').replace(/\s+/g, ' ').trim() : '';
      if (mainBusy || viewCart) {
        button.textContent = mainText ? mainText.toUpperCase() : (IS_FR ? 'AJOUT…' : 'ADDING…');
        button.setAttribute('aria-label', viewCart && !mainBusy ? (IS_FR ? 'Voir le panier' : 'View cart') : mainText || (IS_FR ? 'Ajout…' : 'Adding…'));
      } else {
        button.textContent = defaultLabel;
        button.setAttribute('aria-label', (IS_FR ? 'Ajouter ' : 'Add ') + state.title + (priceLabel ? ' — ' + priceLabel : ''));
      }
    }

    component.__ifungiState = state;
    component.setAttribute('data-purchase-type', state.purchaseType);
    component.setAttribute('data-servings', String(state.servings));
    component.setAttribute('data-bags', String(state.bags));
    component.dispatchEvent(new CustomEvent('ifungi:sticky-state', {
      bubbles: true,
      detail: state
    }));
  }

  function syncVisibility(component) {
    var mainButton = document.querySelector(component.getAttribute('data-main-atc'));
    var stickyButton = component.querySelector('[data-ifungi-sticky-atc]');
    if (!mainButton) return;
    var shouldShow = mainButton.getBoundingClientRect().bottom < 0;
    component.classList.toggle('is-visible', shouldShow);
    component.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    if (stickyButton) stickyButton.tabIndex = shouldShow ? 0 : -1;
  }

  function init(component) {
    if (component.__ifungiStickyInitialized) return;
    component.__ifungiStickyInitialized = true;

    var stickyButton = component.querySelector('[data-ifungi-sticky-atc]');
    var mainSelector = component.getAttribute('data-main-atc');
    var mainButton = document.querySelector(mainSelector);
    if (!mainButton || !stickyButton) return;

    stickyButton.addEventListener('click', function (event) {
      event.preventDefault();
      if (!mainButton.disabled) mainButton.click();
    });

    var buyBoxRoot = mainButton.closest('[class*="hero-right"], [class*="buybox"], section') || mainButton.parentElement;
    if (buyBoxRoot && window.MutationObserver) {
      var observer = new MutationObserver(function () { schedule(component); });
      observer.observe(buyBoxRoot, {
        childList: true,
        characterData: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'disabled', 'hidden', 'aria-selected', 'aria-expanded', 'data-ifungi-view-cart']
      });
      component.__ifungiObserver = observer;
    }

    ['click', 'change', 'input'].forEach(function (type) {
      document.addEventListener(type, function (event) {
        var target = event.target;
        if (!target || !buyBoxRoot || !buyBoxRoot.contains(target)) return;
        window.setTimeout(function () { schedule(component); }, 0);
      }, true);
    });

    var visibilityQueued = false;
    function queueVisibility() {
      if (visibilityQueued) return;
      visibilityQueued = true;
      window.requestAnimationFrame(function () {
        visibilityQueued = false;
        syncVisibility(component);
      });
    }
    window.addEventListener('scroll', queueVisibility, { passive: true });
    window.addEventListener('resize', queueVisibility, { passive: true });

    components.push(component);
    window.setTimeout(function () {
      sync(component);
      syncVisibility(component);
    }, 0);
    window.setTimeout(function () { sync(component); }, 350);
  }

  function initAll() {
    document.querySelectorAll('[data-ifungi-sticky-cart]').forEach(init);
  }

  window.__ifungiStickyCart = {
    version: '1.5.0',
    syncAll: function () { components.forEach(sync); },
    states: function () { return components.map(function (component) { return component.__ifungiState; }); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
